<template>
	<div id="footer">
		<div class="list_group">
			<ul v-for="ul in $store.state.aIndexMenu">
				<label v-if="ul.sub" @click="fnToRouter(ul.path)">{{ul.name}}</label>
				<li v-if="ul.sub" @click="fnToRouter(i.path)" v-for="i in ul.sub">{{i.name}}</li>
			</ul>
			<ul>
				<li>联系我们</li>
				<li v-for="item in about" @click="toWan(item.url)">
					<i class="iconfont" :class="item.icon"></i>
				</li>
			</ul>
		</div>
		<footer>
			<div>2016版权</div>
			<div>厦门酷联客电子科技有限公司</div>
			<img @click="toTop" src="../assets/img/index/toTop.png" />
		</footer>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				"about": [{
						"icon": "icon-111"
					},
					{
						"icon": "icon-weixin"
					},
					{
						"icon": "icon-xinlang"
					},
					{
						"icon": "icon-taobao",
						"url": "https://qlinkcc.taobao.com/?qq-pf-to=pcqq.c2c"
					},
				]
			}
		},
		computed: {},		
		props: {
		},
		methods: {
			toTop: function() {
				if(this.$route.path == "/"){
					this.$store.state.oHomePage.index = 1;
				}else{
					var scrollTop = window.pageYOffset ||
						document.documentElement.scrollTop ||
						document.body.scrollTop ||
						0;
					if(scrollTop > 0) {
						var t1 = window.setInterval(function() {
							if(scrollTop > 100) {
								scrollTo(0, scrollTop /= 1.3)
							} else {
								scrollTo(0, 0);
								window.clearInterval(t1);
							}
						}, 20);
					}
				}
				
			},
			topage: function(url) {
				this.fnToRouter(url);
			},
			toWan: function(url) {
				window.location.href = url;
			}
		},
		components: {},
		created() {},
		mounted() {}
	}
</script>
<style lang="less">
	@import url("../assets/common.less");
	#footer {
		background-color: #212930;
		height: 40vh;
		position: relative;
		&>.list_group {
			padding: 0 8vw;
			overflow: hidden;
			color: #6a8ead;
			font-size: 14px;
			padding-top: 3vh;
			font-size: 12px;
			&>ul {
				width: 20%;
				float: left;
				&>label{
					cursor: pointer;
				}
				&>li {
					padding: 0.5vw;
					color: fadeout(#6a8ead, 50%);
					cursor: pointer;
					&:hover,
					& i:hover {
						color: #6a8ead;
					}
					& i {
						padding: 10px;
					}
				}
			}
			&>ul:last-child {
				&>li:not(:first-child) {
					float: left;
				}
			}
		}
		&>footer {
			@height: 25px;
			background-color: darken(@background-color, 5%);
			height: @height;
			& * {
				color: lighten(@font-color-blue, 20%);
				font-size: 12px;
			}
			& div,
			& li {
				height: @height;
				line-height: @height;
			}
			& li:hover,
			& li:hover *,
			& .el-button:hover,
			& .el-button:hover * {
				color: lighten(@font-color-blue, 40%);
				cursor: pointer;
			}
			& .el-button {
				border: 1px solid transparent;
			}
			& .el-button:hover {
				border: 1px solid lighten(@font-color-blue, 40%);
			}
			& i {
				padding-right: 5px;
			}
			bottom: 0;
			width: 100%;
			position: absolute;
			&>div {
				float: left;
				padding-left: 20px;
				padding-right: 5vw;
			}
			&>img {
				float: right;
				width: 20px;
				cursor: pointer;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// footer.vue?4a77bdba